import { render, staticRenderFns } from "./CustomerInquiry.vue?vue&type=template&id=1954580d&scoped=true"
import script from "./CustomerInquiry.vue?vue&type=script&lang=js"
export * from "./CustomerInquiry.vue?vue&type=script&lang=js"
import style0 from "./CustomerInquiry.vue?vue&type=style&index=0&id=1954580d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954580d",
  null
  
)

export default component.exports